<div class="dialog-wrapper content-creation">
  <h2 *ngIf="isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarVideoPost.createTitle" | translate }}
  </h2>
  <h2 *ngIf="!isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarVideoPost.updateTitle" | translate }}
  </h2>
  <mat-dialog-content>
    <form>
      <section class="upload-image">
        <div class="image-upload-area">
          <h3>
            {{
              "brand.campaign.contentCalendarVideoPost.postImage" | translate
            }}
            <app-tooltip
              text="{{
                'brand.campaign.contentCalendarVideoPost.postImageToolTip'
                  | translate
              }}"
            ></app-tooltip>
          </h3>
          <img *ngIf="post.image" class="preview-image" [src]="post.image" />

          <app-file-uploader
            [uploaderTitle]="
              'brand.campaign.contentCalendarVideoPost.dragAndDropImage'
                | translate
            "
            [uploaderSubtitle]="imageUploaderSubtitle"
            (apiResponse)="handleImageUploadResponse($event)"
            [uploadUrl]="uploaderUrl"
            [uploadData]="uploadData"
            [fieldName]="uploaderFieldName"
            [acceptFormat]="acceptImageFormat"
            (uploadError)="fileUploaderErrorHandler($event)"
            [maxFileSize]="MAX_IMAGE_UPLOAD_SIZE_IN_BYTES"
            [responseMapper]="imagefileUploaderResponseMapper"
          />
        </div>
        <div class="video-upload-area">
          <h3>
            {{
              "brand.campaign.contentCalendarVideoPost.postVideo" | translate
            }}
            <app-tooltip
              text="{{
                'brand.campaign.contentCalendarVideoPost.postVideoToolTip'
                  | translate
              }}"
            ></app-tooltip>
          </h3>
          <video
            *ngIf="post.videoUrl"
            style="width: 100%"
            src="{{ post.videoUrl }}"
            controls
          ></video>
          <app-file-uploader
            [uploaderTitle]="
              'brand.campaign.contentCalendarVideoPost.dragDropVideo'
                | translate
            "
            [uploaderSubtitle]="videoUploaderSubtitle"
            (apiResponse)="handleVideoUploadResponse($event)"
            [uploadUrl]="uploaderUrl"
            [uploadData]="uploadData"
            [fieldName]="uploaderFieldName"
            [acceptFormat]="acceptVideoFormat"
            (uploadError)="fileUploaderErrorHandler($event)"
            [maxFileSize]="maxVideoFileSizeInBytes"
            [maxVideoDurationMinutes]="MAX_VIDEO_DURATION_MINUTES"
            [responseMapper]="videofileUploaderResponseMapper"
          />
        </div>
      </section>

      <app-brand-campaign-content-form-post-suggested-text
        *ngIf="postTags"
        #suggestedText
        (textChanged)="onTextChanged($event)"
        [text]="post.text"
        [postTags]="postTags"
        [type]="campaign.type"
      >
      </app-brand-campaign-content-form-post-suggested-text>
      <section class="channels">
        <h3 class="channels-title">
          {{ "brand.campaign.contentCalendarPost.chooseChannels" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarPost.chooseChannelsToolTip'
                | translate
            }}"
          ></app-tooltip>
        </h3>
        <mat-checkbox
          class="channels-checkbox"
          name="facebookPlatform"
          [(ngModel)]="post.postToFacebook"
          (change)="updateSaveDisabled()"
        >
          Facebook
        </mat-checkbox>
        <mat-checkbox
          [disabled]="isPostToInstagramDisabled"
          class="channels-checkbox channels-checkbox--right"
          name="instagramPlatform"
          [(ngModel)]="post.postToInstagram"
          (change)="updateSaveDisabled()"
        >
          Instagram
        </mat-checkbox>

        <div *ngIf="isPostToInstagramDisabled" class="channels-warning">
          {{
            "brand.campaign.contentCalendarVideoPost.instagramDisabledVideoTooLong"
              | translate
          }}
        </div>
      </section>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="onSaveContent()"
      [disabled]="isSaveDisabled"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{
        "brand.campaign.contentCalendarPost.savePost" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
